import { createSelector } from 'reselect';


export const getOrgSettings = settingName => state =>
  state.organizationSettings.items[settingName];

export const getIsFetchingFromState = stateName => state => (
  state[stateName]
  && state[stateName].isFetching
);

export const getIdsFromState = stateName => state => state[stateName].ids;
export const getIdsFromProps = propName => (_, props) => props[propName] || [];

export const getItemsFromState = stateName => state => state[stateName].items;

export const getDataFromState = stateName => createSelector(
  [getIdsFromState(stateName), getItemsFromState(stateName)],
  (ids, items) => ids.map(id => items[id]).filter(item => item),
);

export const getDataFromStateAndProps = stateName => createSelector(
  [getIdsFromProps(stateName), getItemsFromState(stateName)],
  (ids, items) => ids.map(id => items[id]).filter(item => item),
);

export const getItemById = (stateName, propName) => (state, props) =>
  state[stateName].items[props[propName]];



// WEBPACK FOOTER //
// ./src/redux/selectors/common.js